


































import { Vue } from "vue-property-decorator";
import IndividusCard from "./individus-card.vue";
import { Individu } from "@/models/Individu";

export default Vue.extend({
  data() {
    return {
      rechercheActif: false,
      inputRecherche: "",
      listEnfants: this.enfants as Array<Individu>
    };
  },
  props: {
    alphabet: {
      type: String
    },
    enfants: {
      type: Array,
      default: () => []
    },
    currentEtablissement: {
      type: Object
    },
    autori: {
      type: Number
    }
  },
  components: {
    IndividusCard
  },
  methods: {
    groupByLetters(letter: string) {
      let sortedList: Array<Individu> = [];
      sortedList = this.listEnfants.filter(function(enfant: Individu) {
        if (
          enfant
            .getDisplayName()
            .charAt(0)
            .toLowerCase() === letter.charAt(0).toLowerCase()
        ) {
          return enfant;
        }
      });
      return sortedList;
    },
    closeRecherche() {
      this.inputRecherche = "";
      this.listEnfants = this.enfants as Array<Individu>;
      this.rechercheActif = false;
    }
  },
  watch: {
    inputRecherche(newval: string, oldval: string) {
      if (newval != "") {
        this.listEnfants = this.listEnfants.filter((item: Individu) => {
          if (
            item
              .getDisplayName()
              .toLowerCase()
              .includes(newval.toLowerCase())
          ) {
            return item;
          }
        });
      } else {
        this.listEnfants = this.enfants as Array<Individu>;
      }
    },
    enfants(newVal, oldVal) {
      this.listEnfants = newVal;
    }
  }
});
